export default "__VITE_ASSET__Ede2zE1d__"